// "use client";
// import { useState, useEffect } from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faChevronUp } from "@fortawesome/free-solid-svg-icons";

// export default function ScrollTopAndStepper() {
//   const [isVisible, setIsVisible] = useState(false);
//   const [progress, setProgress] = useState(0);

//   // Show button when scrolled down & Track Progress
//   useEffect(() => {
//     const handleScroll = () => {
//       const scrollTop = window.scrollY;
//       const docHeight =
//         document.documentElement.scrollHeight - window.innerHeight;
//       const scrolled = (scrollTop / docHeight) * 100;

//       setProgress(scrolled);
//       setIsVisible(scrollTop > 300);
//     };

//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   // Scroll to top function
//   const scrollToTop = () => {
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   };

//   return (
//     <>
//       {/* Stepper / Progress Bar */}
//       <div className="fixed top-0 left-0 w-full z-50">
//         <div
//           className="h-1 bg-main1 transition-all duration-300"
//           style={{ width: `${progress}%` }}
//         ></div>
//       </div>

//       {/* Scroll-to-top Button */}
//       <button
//         onClick={scrollToTop}
//         className={`fixed bottom-7 right-2 z-50 px-4 py-3 rounded-full bg-main1 text-white shadow-xl hover:bg-main transition-all duration-300 ${
//           isVisible
//             ? "opacity-100 scale-100 animate-zoomInOut"
//             : "opacity-0 scale-0"
//         }`}
//       >
//         <FontAwesomeIcon icon={faChevronUp} size="sm" />
//       </button>

//       {/* Add animation styles */}
//       <style jsx>{`
//         @keyframes zoomInOut {
//           0%,
//           100% {
//             transform: scale(1);
//           }
//           50% {
//             transform: scale(1.1);
//           }
//         }

//         .animate-zoomInOut {
//           animation: zoomInOut 1.5s infinite ease-in-out;
//         }
//       `}</style>
//     </>
//   );
// }


import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";

const ScrollTopAndStepper = () => {
  const [scrollProgress, setScrollProgress] = useState(0);
  const [showButton, setShowButton] = useState(false);

  const handleScroll = () => {
    const scrolled = window.scrollY;
    const height = document.documentElement.scrollHeight - window.innerHeight;
    const progress = (scrolled / height) * 100;
    setScrollProgress(progress);
    setShowButton(scrolled > 200);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const strokeDasharray = 100;
  const strokeDashoffset = 100 - scrollProgress;

  return (
    <>
      {showButton && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-5  animate-pulse cursor-pointer right-5 z-50 w-10 h-10 rounded-full bg-black/80 text-white flex items-center justify-center shadow-lg hover:scale-110 transition duration-300"
          aria-label="Scroll to top"
        >
          <svg className="absolute w-12 h-12 -z-10" viewBox="0 0 36 36">
            <path
              className="text-gray-700"
              d="M18 2.0845
                 a 15.9155 15.9155 0 0 1 0 31.831
                 a 15.9155 15.9155 0 0 1 0 -31.831"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            />
            <path
              className="text-gradient-to-r from-green-400 to-cyan-500"
              d="M18 2.0845
                 a 15.9155 15.9155 0 0 1 0 31.831
                 a 15.9155 15.9155 0 0 1 0 -31.831"
              fill="none"
              stroke="url(#grad)"
              strokeWidth="2.5"
              strokeDasharray={strokeDasharray}
              strokeDashoffset={strokeDashoffset}
              strokeLinecap="round"
            />
            <defs>
              <linearGradient id="grad" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="#22c55e" />
                <stop offset="100%" stopColor="#06b6d4" />
              </linearGradient>
            </defs>
          </svg>
          <FontAwesomeIcon icon={faArrowUp} size="l" />
        </button>
      )}
    </>
  );
};

export default ScrollTopAndStepper;
